import * as React from 'react';
import CancelOrderPageView from '../layouts/CancelOrderPageView';
import { RowDataCancel } from 'src/reducers/liveorderfile';
// import { UserDetail } from '../../reducers/user';

export interface CancelOrderPageViewProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    cancelOrderData: RowDataCancel[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;
}

class CancelOrderPage extends React.Component<CancelOrderPageViewProps> {
    render() {
        return (
            <CancelOrderPageView
                onRowClick={this.props.onRowClick}
                cancelOrderData={this.props.cancelOrderData}
                reload={this.props.reload}
                onDownloadClick={this.props.onDownloadClick}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
        window.scrollTo(0, 0);
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default CancelOrderPage;



// WEBPACK FOOTER //
// ./src/components/CancelOrderPage/CancelOrderPage.tsx